const initialState = {
  fetching: false,
};

export default function dayReducer(currentState = initialState, action) {
  switch (action.type) {
    case 'FETCHING_DAYS':
      return { ...currentState, fetching: true };
    case 'FETCHED_DAYS':
      return { ...currentState, data: action.payload.data, fetching: false };
    default:
      return currentState;
  }
}
